module.exports = __webpack_public_path__ + "static/img/product-header.ba8cfc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-header.png
// module id = kOet
// module chunks = 10